import { EdgeTypes } from "reactflow";

import PlaceholderEdge from "./PlaceholderEdge";
import WorkflowEdge from "./WorkflowEdge";


export const edgeTypes: EdgeTypes = {
    placeholder: PlaceholderEdge,
    workflow: WorkflowEdge,
}